<script>
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import EntityList from '../../components/entity/entity_list.svelte'
  import { Button } from '../../components/ui'

  let { colleges = [] } = $props()
</script>

<Layout>
  <PageHeader title="Colleges" subtitle="Schools within each college town" count={colleges.length}>
    {#snippet actions()}
      <Button href="/colleges/new" variant="primary" size="sm" icon="add">New College</Button>
    {/snippet}
  </PageHeader>

  <EntityList entity="college" rows={colleges} />
</Layout>
